import { lazy, Suspense } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Loader2, ArrowLeft } from 'lucide-react';
import { ROUTES } from '../components/Navigation/routes';

// Map resource slug → existing page component
const SLUG_COMPONENT_MAP = {
  'inmaps-indoor-navigation':        lazy(() => import('./CaseStudies/CaseStudy1')),
  'agentic-bim-compliance-checker':  lazy(() => import('./CaseStudies/CaseStudy2')),
  'construction-tech-solutions':     lazy(() => import('./IndustrySol/ConstructionTech')),
  'ecommerce-solutions':             lazy(() => import('./IndustrySol/Fintech')),
  'creative-industries-solutions':   lazy(() => import('./IndustrySol/CreativeIndustries')),
};

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center">
    <Loader2 className="w-6 h-6 animate-spin text-purple-500" />
  </div>
);

const NotFound = ({ slug }) => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-center px-4">
    <p className="text-gray-500 text-lg">Resource <span className="font-mono text-gray-700">"{slug}"</span> not found.</p>
    <Link
      to={ROUTES.RESOURCES}
      className="flex items-center gap-1.5 text-sm font-medium text-purple-600 hover:text-purple-800 transition-colors"
    >
      <ArrowLeft className="w-4 h-4" />
      Back to Resources
    </Link>
  </div>
);

const ResourceDetail = () => {
  const { slug } = useParams();
  const PageComponent = SLUG_COMPONENT_MAP[slug];

  if (!PageComponent) return <NotFound slug={slug} />;

  return (
    <Suspense fallback={<Loading />}>
      <PageComponent />
    </Suspense>
  );
};

export default ResourceDetail;
